<template>
	<div class="quiz form-questions">
		<div class="quiz-question" v-for="(question, index) in questions" :key="question.text" v-show="index === questionIndex">
			<div class="quiz-body">
				<span class="text-sm">Question {{ index + 1 }} of {{ questions.length }}</span>
				<h2 class="quiz-response-heading">{{ question.text }}</h2>

				<img class="quiz-response-image" v-if="question.poster_image" :src="question.poster_image">

				<el-radio-group v-model="userResponses[index]" class="quiz-response-group">
					<template v-for="(response, responseIndex) in question.options">
					    <el-radio
					    	class="quiz-response"
					    	:label="response.correct"
				    	 	:key="responseIndex"
				    	 	:class="responseClass(response, responseIndex, index)"
				    	 	:disabled="!!questionAnswered(index)"
				    	 >{{ response.name }}</el-radio>
				    </template>
				</el-radio-group>
			</div>
			<div class="quiz-footer" v-if="questionAnswered(index)">
				<p v-if="question.explanation" class="quiz-description">{{ question.explanation }}</p>
				<button class="btn btn-outline-white" @click="next" v-waves.light>Continue</button>
			</div>
		</div>

		<div class="quiz-body text-center" v-if="completed">
			<slot name="completion-heading">Quiz Completed.</slot>
			<p class="color-info" v-html="completedMessage"></p>
			<p>
				<a class="btn btn-outline-primary" role="button" @click="reset" v-waves.light>{{ resetText }}</a>
			</p>
		</div>
	</div>
</template>

<script>
	let Http = require('../mixins/http');

	export default {
		mixins: [Http],

		props: {
			questions: {
				required: true,
				type: Array
			},
			resetText: {
				required: true,
				type: String
			},
			start: {
				type: Number,
				default: 0
			},
			courseId: {
				type: Number,
				required: true
			}
		},

		data() {
			return {
				questionIndex: 0,
				userResponses: Array(this.questions.length).fill(false)
			}
		},

		computed: {
			completed() {
				return this.questionIndex === this.questions.length;
			},

			completedMessage() {
				let questionCount = this.questions.length,
					userScore = this.score() / questionCount * 100;

				if(userScore >= 80) {
					return 'Congratulations, well done! Your final score is ' + this.scoreRatio + '. Move on to something more challenging!';
				} else if(userScore < 50) {
					return 'Almost there! Your score is ' + this.scoreRatio + '. Continue to persist! Re-watch the videos, practice all of the techniques, and prepare for the quiz again.';
				} else {
					return 'Good job! Your final score is ' + this.scoreRatio + '. There’s room for improvement. Go back, practice, and retake the quiz.';
				}
			},

			scoreRatio() {
				return '<strong>' + this.score() + '</strong> out of <strong>' + this.questions.length + '</strong>';
			}
		},

		methods: {
			score: function() {
				return this.userResponses.filter(function(val) { return val }).length;
			},

			next() {
				this.questionIndex++;

				if(this.completed) {
					// save to db
					this.sendRequest('/api/save-quiz-result', 'POST', function(){

					}, {
						course_id: this.courseId,
						result: this.score(),
						total: this.questions.length
					});
				}
			},

			reset() {
				this.$emit('reset', this);
				this.questionIndex = 0;
				this.userResponses.fill(false);
			},

			responseClass: function(response, responseIndex, index) {
				if(this.questionAnswered(index)) {
					if(response.correct) {
						return 'is-correct';
					} else if(this.userResponses[index] === (responseIndex + 1)) {
						return 'is-incorrect';
					} else {
						return 'is-disabled';
					}
				}
			},

			questionAnswered: function(index) {
				return this.userResponses[index] !== false;
			}
		}
	}
</script>
